/** @format */

// Local var name `moment` retained across the codebase per the dayjs-setup
// minimal-diff strategy (see config/dayjs-setup.js). The duration / utc /
// relativeTime plugins are extended globally there.
import moment, { ConfigType } from 'dayjs';
import type { Duration } from 'dayjs/plugin/duration';
import { i18n } from '../pages/private/languageSelector';
import { TEXT_DIRECTION } from './helperFunctions';

export const getFormLastModifiedDate = (
  udpatedAt: ConfigType,
  type?: string, // kept in signature for call-site compatibility; body branches were commented out
): string => {
  // suppress unused warning for `type` — kept for the legacy template branches at the bottom.
  void type;
  const duration = getDurationBetweenTwoDates(udpatedAt, new Date());
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const formatedDuration = days ? `${days}d` : hours ? `${hours}h` : minutes ? `${minutes}m` : seconds ? `${seconds}s` : '';
  return formatedDuration
    ? `
        ${formatedDuration} ${i18n('global.Ago')}`
    : '-';
};
// ${
//   type === "archived"
//   ? i18n("global.Archived")
//   : i18n("global.LastModifed")
// }

export const getNotificationTime = (time: ConfigType): string => {
  const duration = getDurationBetweenTwoDates(time, new Date());
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const formatedDuration = days ? `${days}d` : hours ? `${hours}h` : minutes ? `${minutes}m` : seconds ? `${seconds}s` : '';
  return formatedDuration && TEXT_DIRECTION() === 'rtl' ? `${i18n('global.Ago')}  ${formatedDuration}` : `${formatedDuration} ${i18n('global.Ago')}`;
};

const getDurationBetweenTwoDates = (startDateTime: ConfigType, endDateTime: ConfigType): Duration => {
  return moment.duration(moment(endDateTime).diff(startDateTime));
};

export const getDeviceLastLoginTime = (lastLogin: ConfigType, timeZone?: string): string => {
  if (!lastLogin) return '-';
  const offsetMatch = typeof timeZone === 'string' ? timeZone.match(/GMT\s*([+-]\d{1,2}(?::?\d{2})?)/i) : null;
  const parsed = offsetMatch ? moment(lastLogin).utcOffset(offsetMatch[1]) : moment(lastLogin);
  if (!parsed.isValid()) return '-';
  return parsed.format('DD MMM YYYY HH:mm:ss');
};

export const getDeviceRegisteredTime = (objectId?: string): Date | null => {
  if (typeof objectId === 'string' && /^[0-9a-fA-F]{24}$/.test(objectId)) {
    return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
  }
  return null;
};
